/**
 * Monta o resumo do card "Tutoriais" (Admin Geral) cruzando as linhas de progresso da empresa
 * (admin/companies/get.php → tutorials) com as lições atuais de tutorials.json. A ligação é
 * sempre pelo id fixo da lição; ids que saíram do JSON são ignorados. As respostas de
 * "Esta aula ajudou?" contam só a versão atual de cada lição (vídeo novo, avaliação nova).
 *
 * @param {Array} rows - [{ lesson_id, user_id, last_watched_at, views, help_views, completed_at, helpful, helpful_version }]
 * @param {Array} chapters - capítulos de useTutorialChapters()
 * @param {Array} users - usuários da empresa (get.php → users)
 */
const companyTutorialsSummary = (rows, chapters, users) => {
  const lessonsById = {};
  chapters.forEach((chapter) => (chapter.lessons || []).forEach((lesson) => {
    lessonsById[lesson.id] = { ...lesson, chapterTitle: chapter.title, chapterNumber: chapter.number };
  }));
  const totalLessons = Object.keys(lessonsById).length;
  const known = (rows || []).filter((row) => lessonsById[row.lesson_id]);

  const completedLessons = new Set(known.filter((row) => row.completed_at).map((row) => row.lesson_id));
  const lastWatchedAt = known.reduce((max, row) => (!max || row.last_watched_at > max ? row.last_watched_at : max), null);

  const perUser = (users || []).map((user) => {
    const own = known.filter((row) => row.user_id === user.id);
    const latest = own.reduce((acc, row) => (!acc || row.last_watched_at > acc.last_watched_at ? row : acc), null);
    return {
      id: user.id,
      name: user.name || user.email,
      opened: own.length,
      completed: own.filter((row) => row.completed_at).length,
      lastWatchedAt: latest ? latest.last_watched_at : null,
      currentChapter: latest ? lessonsById[latest.lesson_id].chapterTitle : null
    };
  });

  // Onde a equipe travou: lições abertas pelo atalho "Como usar esta tela"
  const helpByLesson = {};
  known.filter((row) => row.help_views > 0).forEach((row) => {
    helpByLesson[row.lesson_id] = (helpByLesson[row.lesson_id] || 0) + row.help_views;
  });
  const fromHelp = Object.entries(helpByLesson)
    .map(([lessonId, views]) => ({ lessonId, title: lessonsById[lessonId].title, views }))
    .sort((a, b) => b.views - a.views);

  const currentAnswers = known.filter((row) => row.helpful !== null
    && (row.helpful_version || 1) === (lessonsById[row.lesson_id].version || 1));
  const notHelpfulRows = currentAnswers.filter((row) => row.helpful === 0);
  const notHelpful = [...new Set(notHelpfulRows.map((row) => row.lesson_id))]
    .map((lessonId) => ({ lessonId, title: lessonsById[lessonId].title }));

  return {
    totalLessons,
    completedLessons: completedLessons.size,
    lastWatchedAt,
    usersWatching: perUser.filter((user) => user.opened > 0).length,
    perUser,
    fromHelp,
    helpViews: fromHelp.reduce((sum, item) => sum + item.views, 0),
    helpfulYes: currentAnswers.filter((row) => row.helpful === 1).length,
    helpfulNo: notHelpfulRows.length,
    notHelpful
  };
};

export default companyTutorialsSummary;
